import { BaseApplicantDetails } from "ts/interfaces/common/applicants";
import {
  APPLICATION_COMPLETE_KEY,
  APPLICATION_ERROR_CODES,
  APPLICATION_IN_PROGRESS_KEY,
} from "utils/consts";

type ApplicationError = { code: string; message: string };

export const getPricingExpiredError = (payload?: {
  errors?: Record<string, ApplicationError[]>;
}): ApplicationError | null =>
  Object.values(payload?.errors ?? {})
    .flat()
    .find((e) => e.code === APPLICATION_ERROR_CODES.PRODUCT_PRICING_EXPIRED) ??
  null;

export const SELECT_OPTION_OTHER = "O";

export const canContinueApplication = (status: string) =>
  status === APPLICATION_IN_PROGRESS_KEY;

export const isCaseComplete = (status: string | undefined) =>
  status === APPLICATION_COMPLETE_KEY;

export const getApplicantName = (applicant: BaseApplicantDetails) =>
  applicant?.forename && applicant?.surname
    ? `${applicant.forename} ${applicant.surname}`
    : "";
